import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './GenresList.html?raw';

import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import EntityStore from '../../../moreCore/Tools/EntityStore';
import lang from 'dojo/_base/lang';
import _StatefulSection from '../../../moreCore/UI/_StatefulSection/_StatefulSection';
import { VAM2types, VAMclassNames } from "../../_loadingHelpers/VAMv2Types";
import _GlobalSelectEntityDialogsMixin from '../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import { SelectEntityDialogTypes } from "../../../moreCore/_loadingHelpers/SelectEntityDialog";
import { StringHelpers } from "../../../more/Helpers";

class GenresList extends compose(_StatefulSection, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    private btnReload: HTMLElement;
    private btnNew: HTMLElement;
    private tableContainer: HTMLDivElement;
    private table: MdsLax<InstanceType<typeof StaticTable>>;
    private store: MdsLax<InstanceType<typeof EntityStore<VAM2types.GenreEntry>>>;

    private crud: VAM2types.CrudPrivilages = null;

    protected afterSetData(): void {
        super.afterSetData.apply(this, arguments as any);

        this.hideNode(this.btnReload, !this.entityId);

        let data = this.getAttributeValue("genres");
        if (this.getAttributeValue("genresDiffData") == null) this.store.setup(data);
    }

    private _onStoreChange(e) {
        let diffData = lang.clone(this.store.getDiffData());

        this.setAttributeValue("genresDiffData", diffData);
    }

    private _onClickReload() {
        this._reload();
    }
    private _reload(): void {

        this.StandbyStart();
        let entityID = this.getAttributeValue("ID");
        let classname = this.getAttributeValue("Classname");
        let data = { bookingID: entityID, classname: classname };

        this.RequestManager.callfunction("Webtool_API_EvBooking__Genres_GetListData",
            data,
            lang.hitch(this, this._onReloadResponse),
            (err) => {
                this.showToast(err.Message);
                this.StandbyStop();
            });
    }

    private _onReloadResponse(response: Array<VAM2types.GenreEntry>): void {
        this.StandbyStop();
        this.store.setup(response);
        this.updateTable();
        this.emit("reloaded");
    }
    private _setupTable(response: { layouts: Array<any> }) {
        if (this.table != null) this.table.destroy();

        this.table = new StaticTable();
        this.table.placeAt(this.tableContainer);

        this.table.setLayout(response.layouts[0]);
        if (this.crud.hasRead) {
            // this.table.setRowClick(lang.hitch(this, this._onTableRowClick));
            // this.table.addDefaultRowActionButton("view", lang.hitch(this, this._onClick_ViewBtn))
        }

        if (this.crud.hasDelete) this.table.addDefaultRowActionButton("delete");

        this.table.setCyAttribute("genresList");

        this.updateTable();
    }

    private updateTable() {

        this.table.setupFromStore(this.store);
    }

    // private _onClick_ViewBtn(rowGroup: StaticTable.StaticTableRowGroup<VAM2types.GenreEntry>) {

    //     this.showEntityView(rowGroup.entity.genreID)
    // }

    // private _onTableRowClick(row: StaticTable.StaticTableRow<VAM2types.GenreEntry>, rowGroup: StaticTable.StaticTableRowGroup<VAM2types.GenreEntry>, evt: Event) {

    //     this.showEntityView(rowGroup.entity.genreID)
    // }
    // private showEntityView(entityID: string) {

    //     let entityView = new GenericEntityView();

    //     entityView.setup(entityID, VAMclassNames.ev_genres, "", "", "dlg");
    // }

    hasData(): boolean {
        let completeList = this.store.getCurrentCompleteList();
        let deleteList = this.store.getCurrentCompleteList("deleted");
        let response = false;

        if (deleteList.length > 0) completeList.forEach(e => { if (deleteList.indexOf(e) == -1) response = true; });
        else response = completeList.length > 0;

        return response;
    }

    disableEdit(disable: boolean = true) {

        this.disableNode(this.btnNew, disable);
        this.table?.enableActionButton("delete", null, !disable);
    }

    private _onClickAdd(evt) {
        if (this.crud.hasCreate !== true) return;

        this.loadSelectEntityDialog(evt,
            "selectGenres",
            lang.hitch(this, this._onCallback_Dlg)
        );
    }

    private _onCallback_Dlg(mode: string, data, items: Array<SelectEntityDialogTypes.Item<VAM2types.Genre>>) {
        // fake-entity falls das zurückgeleiferte Entity aus items[0].entry.data nicht dem entspricht das die liste erwartet

        if (!items || !items.length) return;
        if (mode == "selectGenres") {
            for (let item of items) {

                let entity: Partial<VAM2types.Genre> = item.entry?.data;

                if (!entity) {
                    entity = {
                        ID: item.entry.value, description: item.entry.label
                    };
                }
                else {

                }

                this.addNewEntry(entity as any);
            }
        }
    }
    private addNewEntry(value: VAM2types.Genre) {
        if (value != null) {

            let fakeChannel: Partial<VAM2types.GenreEntry> = {
                ID: StringHelpers.randomID(16),
                genreID: value.ID,
                ref_ev_genre: value
            }

            if (this.store.isEntityExisting(fakeChannel as any, "genreID", true)) {
                this.showToast({
                    title: this.translate(`GenresList_Toast_ExistInList`),
                    message: `**${value.description}**  ${this.translate(`GenresList_Toast_ExistInList_details`)}`,
                    messageIcon: "fas fa-info-circle",
                    iconClass: "fas fa-info-circle"
                });
            }
            else {
                this.store.addEntry(fakeChannel as any, "new");
            }
        }
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        if (!this.hasFeature("EvBooking/Genres") || !this.hasUserRole("EvBooking_Genres")) {
            return;
        }

        this.store = new EntityStore
        this.store.on("change", lang.hitch(this, this._onStoreChange));

        this.RequestManager.callfunction(
            "Webtool_API_EvBooking__Genres_GetGenresTableLayout",
            null,
            lang.hitch(this, this._setupTable),
            (err) => {
                if (this.hasFeature("EvBooking/Genres") && this.hasUserRole("EvBooking_Genres")) {

                    this.showToast(err.Message);
                }
            }
        )

        this.SEDconfigCallfunction = "Webtool_API_EvBooking__SED_GetConfig";

        this.crud = {
            hasRead: this.hasUserRole("EvBooking_Genres_Read"),
            hasEdit: this.hasUserRole("EvBooking_Genres_Edit"),
            hasCreate: this.hasUserRole("EvBooking_Genres_Create"),
            hasDelete: this.hasUserRole("EvBooking_Genres_Delete")
        }

        this.disableNode(this.btnNew, !this.crud.hasCreate);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(GenresList);